import React from 'react';

const SpacedDot: React.FC = () => <span className="mx-1"> • </span>;

export default SpacedDot;
